import React from 'react';

class Zigbee3Icon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_1301)">
          <g filter="url(#filter0_d_241_1301)">
            <path
              d="M56.24 4H23.76C20.3027 4 17.5 6.8027 17.5 10.26V69.74C17.5 73.1973 20.3027 76 23.76 76H56.24C59.6973 76 62.5 73.1973 62.5 69.74V10.26C62.5 6.8027 59.6973 4 56.24 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M40.0001 29.4359C43.8903 29.4359 47.0441 26.2822 47.0441 22.3919C47.0441 18.5016 43.8903 15.3479 40.0001 15.3479C36.1098 15.3479 32.9561 18.5016 32.9561 22.3919C32.9561 26.2822 36.1098 29.4359 40.0001 29.4359Z"
              fill="white"
            />
            <path
              d="M40.0001 47.0441C43.8903 47.0441 47.0441 43.8903 47.0441 40.0001C47.0441 36.1098 43.8903 32.9561 40.0001 32.9561C36.1098 32.9561 32.9561 36.1098 32.9561 40.0001C32.9561 43.8903 36.1098 47.0441 40.0001 47.0441Z"
              fill="white"
            />
            <path
              d="M40.0001 64.652C43.8903 64.652 47.0441 61.4983 47.0441 57.608C47.0441 53.7177 43.8903 50.564 40.0001 50.564C36.1098 50.564 32.9561 53.7177 32.9561 57.608C32.9561 61.4983 36.1098 64.652 40.0001 64.652Z"
              fill="white"
            />
            <path
              d="M56.2402 3.19995H23.7602C19.8662 3.19995 16.7002 6.36795 16.7002 10.26V69.74C16.7002 73.634 19.8682 76.8 23.7602 76.8H56.2382C60.1322 76.8 63.2982 73.632 63.2982 69.74V10.26C63.2982 6.36595 60.1302 3.19995 56.2382 3.19995H56.2402ZM61.7002 69.74C61.7002 72.752 59.2502 75.2 56.2402 75.2H23.7602C20.7482 75.2 18.3002 72.75 18.3002 69.74V10.26C18.3002 7.24795 20.7502 4.79995 23.7602 4.79995H56.2382C59.2502 4.79995 61.6982 7.24995 61.6982 10.26V69.74H61.7002Z"
              fill="#84827E"
            />
            <path
              d="M53.05 59.1739C53.6984 59.1739 54.224 58.6483 54.224 57.9999C54.224 57.3515 53.6984 56.8259 53.05 56.8259C52.4016 56.8259 51.876 57.3515 51.876 57.9999C51.876 58.6483 52.4016 59.1739 53.05 59.1739Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 14.5479C35.6763 14.5479 32.1562 18.0659 32.1562 22.3919C32.1562 26.7179 35.6743 30.2358 40.0003 30.2358C44.3263 30.2358 47.8443 26.7179 47.8443 22.3919C47.8443 18.0659 44.3263 14.5479 40.0003 14.5479V14.5479ZM40.0003 28.6339C36.5583 28.6339 33.7563 25.8339 33.7563 22.3899C33.7563 18.9459 36.5563 16.1459 40.0003 16.1459C43.4443 16.1459 46.2443 18.9459 46.2443 22.3899C46.2443 25.8339 43.4443 28.6339 40.0003 28.6339Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 32.156C35.6763 32.156 32.1562 35.674 32.1562 40C32.1562 44.326 35.6743 47.844 40.0003 47.844C44.3263 47.844 47.8443 44.326 47.8443 40C47.8443 35.674 44.3263 32.156 40.0003 32.156ZM40.0003 46.244C36.5583 46.244 33.7563 43.444 33.7563 40C33.7563 36.556 36.5563 33.756 40.0003 33.756C43.4443 33.756 46.2443 36.556 46.2443 40C46.2443 43.444 43.4443 46.244 40.0003 46.244Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 49.7659C35.6763 49.7659 32.1562 53.2839 32.1562 57.6099C32.1562 61.9359 35.6743 65.4539 40.0003 65.4539C44.3263 65.4539 47.8443 61.9359 47.8443 57.6099C47.8443 53.2839 44.3263 49.7659 40.0003 49.7659V49.7659ZM40.0003 63.8519C36.5583 63.8519 33.7563 61.0519 33.7563 57.6079C33.7563 54.1639 36.5563 51.3639 40.0003 51.3639C43.4443 51.3639 46.2443 54.1639 46.2443 57.6079C46.2443 61.0519 43.4443 63.8519 40.0003 63.8519Z"
              fill="#84827E"
            />
            <path
              d="M41.5646 19.6978C41.5646 18.833 40.8639 18.1318 39.9996 18.1318C39.1352 18.1318 38.4346 18.833 38.4346 19.6978V21.5738C38.4346 22.4387 39.1352 23.1398 39.9996 23.1398C40.8639 23.1398 41.5646 22.4387 41.5646 21.5738V19.6978Z"
              fill="url(#paint0_linear_241_1301)"
            />
            <path
              d="M41.5646 37.3079C41.5646 36.4431 40.8639 35.7419 39.9996 35.7419C39.1352 35.7419 38.4346 36.4431 38.4346 37.3079V39.184C38.4346 40.0488 39.1352 40.75 39.9996 40.75C40.8639 40.75 41.5646 40.0488 41.5646 39.184V37.3079Z"
              fill="url(#paint1_linear_241_1301)"
            />
            <path
              d="M41.5646 54.9159C41.5646 54.051 40.8639 53.3499 39.9996 53.3499C39.1352 53.3499 38.4346 54.051 38.4346 54.9159V56.7919C38.4346 57.6567 39.1352 58.3579 39.9996 58.3579C40.8639 58.3579 41.5646 57.6567 41.5646 56.7919V54.9159Z"
              fill="url(#paint2_linear_241_1301)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_1301"
            x="15.3002"
            y="1.79995"
            width="52.5977"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_1301"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_1301"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_1301"
            x1="38.8748"
            y1="18.5798"
            x2="42.1247"
            y2="20.9096"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_1301"
            x1="38.8748"
            y1="36.1899"
            x2="42.1247"
            y2="38.5197"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_241_1301"
            x1="38.8748"
            y1="53.7978"
            x2="42.1247"
            y2="56.1276"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_1301">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default Zigbee3Icon;
